import { createV3Queries } from "@query/utils/createV3Queries";
import { institutionsApi } from "@api";

export const queriesInstitutions = createV3Queries(
  "institutionsApi",
  institutionsApi
);
